module.exports = __webpack_public_path__ + "img/xiayi.5828c339.png";